import {
  HTTP_GETBUDGETCOMPSBYBRAND_FETCHING,
  HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS,
  HTTP_GETBUDGETCOMPSBYBRAND_FAILED,
  HTTP_RESET_GETBUDGETCOMPSBYBRAND,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETCOMPSBYBRAND_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPSBYBRAND_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
